module.exports = __webpack_public_path__ + "static/media/about-adsticker-marketing.b48b338b.png";